/**
 * Hook per accedere ai colori di stato standardizzati
 * Utilizza i colori definiti nel design system
 */

import { useTheme } from '@mui/material/styles';
import { colors } from '../tokens/colors';

export interface StatusColorProps {
  backgroundColor: string;
  color: string;
  borderColor: string;
}

export const useStatusColors = () => {
  const theme = useTheme();

  return {
    active: {
      backgroundColor: colors.semantic.status.active.background,
      color: colors.semantic.status.active.text,
      borderColor: colors.semantic.status.active.border,
    },
    inactive: {
      backgroundColor: colors.semantic.status.inactive.background,
      color: colors.semantic.status.inactive.text,
      borderColor: colors.semantic.status.inactive.border,
    },
    confirmed: {
      backgroundColor: colors.semantic.status.confirmed.background,
      color: colors.semantic.status.confirmed.text,
      borderColor: colors.semantic.status.confirmed.border,
    },
    pending: {
      backgroundColor: colors.semantic.status.pending.background,
      color: colors.semantic.status.pending.text,
      borderColor: colors.semantic.status.pending.border,
    },
    cancelled: {
      backgroundColor: colors.semantic.status.cancelled.background,
      color: colors.semantic.status.cancelled.text,
      borderColor: colors.semantic.status.cancelled.border,
    },
    refunded: {
      backgroundColor: colors.semantic.status.refunded.background,
      color: colors.semantic.status.refunded.text,
      borderColor: colors.semantic.status.refunded.border,
    },
    error: {
      backgroundColor: colors.semantic.status.error.background,
      color: colors.semantic.status.error.text,
      borderColor: colors.semantic.status.error.border,
    },
    marketingConsent: {
      backgroundColor: colors.semantic.status.marketingConsent.background,
      color: colors.semantic.status.marketingConsent.text,
      borderColor: colors.semantic.status.marketingConsent.border,
    },
    marketingConsentDenied: {
      backgroundColor: colors.semantic.status.marketingConsentDenied.background,
      color: colors.semantic.status.marketingConsentDenied.text,
      borderColor: colors.semantic.status.marketingConsentDenied.border,
    },
  };
};

export default useStatusColors;
